import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import CategoryPage from "@/pages/category/page";
import ComicDetailPage from "@/pages/comic/page";
import ReadingPage from "@/pages/read/page";
import AboutPage from "@/pages/about/page";
import Layout from "@/components/feature/Layout";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "category/:slug", element: <CategoryPage /> },
      { path: "comic/:id", element: <ComicDetailPage /> },
      { path: "about", element: <AboutPage /> },
    ],
  },
  {
    path: "/comic/:id/chapter/:num",
    element: <ReadingPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;